/**
 * The homepage's short bio beside the portrait.
 */
import React from "react";
import { useLocales } from "../../core/i18n";
import { AuthorPortrait } from "../../ui/media";
import { Reveal } from "../../ui/motion";
import { CONTAINER, SECTION_PAD } from "../../ui/shell";

/** Three bio paragraphs and the portrait (above them on phones, beside from lg). */
const HomeAbout = () => {
	const { t } = useLocales();
	return (
		<section className={`bg-pp-bg ${SECTION_PAD}`}>
			<div className={CONTAINER}>
				<div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-10 lg:gap-16 items-start">
					<div>
						<Reveal>
							<p className="font-sligoil font-bold text-pp-ink mb-6 text-pp-title-md">
								{t("hero.bio1")}
							</p>
						</Reveal>
						<Reveal delay={80}>
							<p className="text-pp-muted text-base leading-relaxed mb-3 max-w-[62ch]">
								{t("hero.bio2")}
							</p>
						</Reveal>
						<Reveal delay={160}>
							<p className="text-pp-muted text-base leading-relaxed max-w-[62ch]">
								{t("hero.bio3")}
							</p>
						</Reveal>
					</div>
					<Reveal delay={100} className="order-first lg:order-none">
						<AuthorPortrait />
					</Reveal>
				</div>
			</div>
		</section>
	);
};

export default HomeAbout;
